import React from "react";
import "./style/apropos.css"
import Slider from "./slider"
import Apropos from "./apropos"
import Solutions from "./solutions"
import NosValeurs from "./NosValeurs"
import Team from "./team"
import NosProjets from "./NosProjets"
import CatalogueProjetcts from "./catalogueProjetcts"
import AvisGens from "./avisDesGens";
import VieChifco from "./viechifco";
import Partenaires from "./partenaires";
import CarouselResponsive from "../home/responsive/carouselNosValeurs"
import CarouselSolutionResponsive from "../home/responsive/carouselSolution"
import MapAddresse from "../home/mapAdresse"
import NewsLetter from "../home/newsLetter"
import Footer from "../home/footer"
import { Helmet } from "react-helmet";
import TagManager from "react-gtm-module";

// const tagManagerArgs = {
//   dataLayer: {
//     userProject: "Chifco_website",
//     page: "A propos",
//     event:"CHIF_EVENT"
//   },
//   dataLayerName: "PageDataLayer",
// };

const classes = {
  textField : {color:"rgba(0, 0, 0, 0.87)"}
}

class Home extends React.Component {
  componentDidMount(){
    window.scrollTo({ top: 0, behavior: 'smooth' });
}

  render() {
    // TagManager.dataLayer(tagManagerArgs)
    return (
      <div>
         <Helmet>
          <meta charSet="utf-8" />
          <title>A propos</title>
          <link
            rel="canonical"
            href={
             // "https://chifcositev2.chifco.com" +
              process.env.REACT_APP_CLIENT 
            }
          />
        </Helmet>
        <Slider />
        <Apropos />
        <CarouselSolutionResponsive />
        <Solutions /> 
         <CarouselResponsive />
        <NosValeurs />
        <Team />
        <NosProjets />
        <CatalogueProjetcts />
        <AvisGens />
       <VieChifco />
         <Partenaires />
       <MapAddresse />
        <NewsLetter 
        //classes = {classes} 
        />
        <Footer /> 
      </div>
    );
  }
}
export default Home;


// WEBPACK FOOTER //
// ./src/home/index.js